import(/* webpackMode: "eager" */ "/home/node/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/node/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/node/app/node_modules/normalize.css/normalize.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/components/Collapsable/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/components/ContentfulImage/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/components/Copyright/Copyright.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/components/Header/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/components/HomeFooter/HomeFooter.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/components/Layout/Layout.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/components/Button/Button.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/components/LegalPopup/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/components/Partner/Partner.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/components/RichText/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/containers/Casestudy/CasestudyHeader/CasestudyHeader.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/containers/Casestudy/AWSServiceSection/AWSServiceSection.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/node/app/src/containers/Casestudy/Feature/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/containers/Work/Project/Project.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/containers/Casestudy/WorkScope/WorkScope.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/containers/Casestudy/Casestudy.module.scss");
;
import(/* webpackMode: "eager" */ "/home/node/app/src/containers/Casestudy/ClientTestimonial/ClientTestimonial.module.scss");
